// extracted by mini-css-extract-plugin
module.exports = {"postOverlay":"RelatedPostCard_postOverlay__xWTOZ","postTitle":"RelatedPostCard_postTitle__y_puX","postCard":"RelatedPostCard_postCard__Oee99"};